<div class="widget-inner-alert_wrapper">

  <div class="widget-inner-alert_title">
    @if (titleTranslate) {
      {{title | l10n}}
    } @else {
      {{title}}
    }
  </div>

  <div class="widget-inner-alert_body">
    @if (messageTemplate) {
      <ng-container *ngTemplateOutlet="messageTemplate"></ng-container>
    }
    @if (messageTranslate) {
      {{message | l10n:messageTranslationParams}}
    }
    @if (!messageTemplate && !messageTranslate) {
      {{message}}
    }
  </div>

  @if (!buttonRouterLink) {
    <button type="submit" class="widget-inner-alert_button" (click)="close()">
      {{buttonText | l10n}}
    </button>
  }
  @if (buttonRouterLink) {
    <a class="widget-inner-alert_button" [routerLink]="buttonRouterLink">
      {{buttonText | l10n}}
    </a>
  }

  <svg class="widget-inner-alert_close" (click)="close()"><use xlink:href="#close"></use></svg>
</div>
